import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { MatMenuModule } from '@angular/material/menu';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { MsalService } from '@azure/msal-angular';
import { NgxsModule } from '@ngxs/store';
import { environment } from '../environments/environment';
import { APP_ROUTES } from './app.routes';
import { provideInterceptors } from './auth/providers/provide-interceptors';
import { provideMsalConfiguration } from './auth/providers/provide-msal-configuration';
import { provideMsalServices } from './auth/providers/provide-msal-services';
import { initializeMsal } from './auth/utils/auth.utils';
import { QuestionState } from './home/state/question.state';
import { AppTranslateLoader } from './static/services/app-translate-loader.service';
import { LanguageState } from './static/states/language/language.state';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            BrowserModule,
            MatMenuModule,
            TranslateModule.forRoot({
                fallbackLang: 'en',
                loader: {
                    provide: TranslateLoader,
                    useClass: AppTranslateLoader
                }
            }),
            NgxsModule.forRoot([LanguageState, QuestionState], {
                compatibility: {
                    strictContentSecurityPolicy: true
                }
            })
        ),
        provideAppInitializer(() => {
            const initializerFn = initializeMsal(inject(MsalService));
            return initializerFn();
        }),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideAnimations(),
        provideRouter(APP_ROUTES),
        provideMsalServices(),
        provideMsalConfiguration({ msalConfig: environment.msalConfig, apiConfig: environment.apiConfig }),
        provideInterceptors()
    ]
};
